import type { Track, WorkOrder } from '@/api/types'
import { formatDate } from '@/domain/format'
import { PipelineLg } from './Pipeline'
import { Fact, StateBadge } from './atoms'

/** Sección 4 · Seguimiento de la OT seleccionada. */
export function WorkOrderDetail({
  id,
  workOrder,
  track,
}: {
  id: string
  workOrder: WorkOrder | null
  track: Track
}) {
  return (
    <section id={id} className="sec sec-otdetail" aria-labelledby="h-otd">
      <div className="sec-hd">
        <h2 id="h-otd">Seguimiento de la OT</h2>
      </div>
      <div className="sec-in">
        {!workOrder ? (
          <div className="placeholder">
            Elige una orden de trabajo para ver su línea de tiempo.
          </div>
        ) : (
          <article className="card">
            <div className="hd-row">
              <div style={{ minWidth: 0 }}>
                <p className="eyebrow">OT {workOrder.serial ?? '—'}</p>
                <h3 className="title-xl" style={{ fontSize: 17 }}>
                  {workOrder.name}
                </h3>
                <p className="subtitle">{workOrder.provider.display}</p>
              </div>
              <div className="hd-actions">
                <StateBadge state={workOrder.state} />
              </div>
            </div>

            <div className="facts">
              <Fact label="Contrato" value={workOrder.contract.display} />
              <Fact label="Actividad" value={workOrder.activity.display} />
              <Fact label="Inicio" value={formatDate(workOrder.startDate)} numeric />
              <Fact label="Término comprometido" value={formatDate(workOrder.endDate)} numeric />
              <Fact
                label="Avance"
                value={workOrder.state.unknown ? '—' : `${workOrder.progress.percent}%`}
                numeric
              />
            </div>

            <div className="inset">
              <p className="k">Solución</p>
              <p className="v">{workOrder.solution ?? 'No ha sido ingresada una solución'}</p>
            </div>

            <p className="meta" style={{ marginBottom: 2 }}>
              Seguimiento de la orden
            </p>
            <PipelineLg state={workOrder.state} track={track} />
          </article>
        )}
      </div>
    </section>
  )
}
